import { createSelector } from 'reselect'
import { selectDemoMailboxId } from 'selectors/mailboxes'
import { selectShowOnboardingWorkflow } from './index'

export const selectShowOnboardingWorkflowInConversationList = createSelector(
  selectShowOnboardingWorkflow,
  selectDemoMailboxId,
  (showOnboardingWorkflow, demoMailboxId) =>
    showOnboardingWorkflow && !!demoMailboxId
)
